import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  // Our Vision
  {
    path: '/our-vision',
    name: 'Our Vision',
    component: () => import('../views/OurVision.vue'),
  },
  {
    path: '/giving-back',
    name: 'Giving Back',
    component: () => import('../views/GivingBack.vue'),
  },
  {
    path: '/our-team',
    name: 'Our Team',
    component: () => import('../views/OurTeam.vue'),
  },
  {
    path: '/testimonials',
    name: 'Testimonials',
    component: () => import('../views/Testimonials.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/Blog.vue'),
  },
  // Buy
  {
    path: '/properties/for-sale',
    name: 'Properties For Sale',
    component: () => import('../views/PropertiesForSale.vue'),
  },
  {
    path: '/open-homes',
    name: 'Open Homes',
    component: () => import('../views/InspectionTimes.vue'),
  },
  {
    path: '/projects-and-developments',
    name: 'Projects & Developments',
    component: () => import('../views/ProjectsAndDevelopments.vue'),
  },
  {
    path: '/properties/for-sale/homes-and-units',
    name: 'Homes And Appartments',
    component: () => import('../views/PropertiesHomesAndUnits.vue'),
  },
  {
    path: '/properties/for-sale/land',
    name: 'Land',
    component: () => import('../views/PropertiesLand.vue'),
  },
  {
    path: '/properties/for-sale/new-house-and-land-package',
    name: 'New House And Land Package',
    component: () => import('../views/PropertiesNewHouseAndLandPackage.vue'),
  },
  {
    path: '/properties/for-sale/commercial',
    name: 'Commercial',
    component: () => import('../views/PropertiesCommercial.vue'),
  },
  // Sell
  {
    path: '/forms/sales-appraisal',
    name: 'Sales Appraisal',
    component: () => import('../views/SalesAppraisal.vue'),
  },
  {
    path: '/suburb-stories',
    name: 'Suburb Stories',
    component: () => import('../views/SuburbStories.vue'),
  },
  {
    path: '/home-staging',
    name: 'Home Staging',
    component: () => import('../views/HomeStaging.vue'),
  },
  {
    path: '/properties/sold',
    name: 'Sold Properties',
    component: () => import('../views/PropertiesSold.vue'),
  },
  // Rent
  /* {
    path: '/properties/for-rent',
    name: 'Properties For Rent',
    component: () => import('../views/PropertiesForRent.vue'),
  },
  {
    path: '/how-to-complete-a-rental-application-form',
    name: 'How to Complete a Rental Application Form',
    component: () => import('../views/HowToCompleteARentalApplicationForm.vue'),
  }, */
  /* Airbnb
  {
    path: '/airbnb',
    name: 'Airbnb Short Term Management',
    component: () => import('../views/Airbnb.vue'),
  }, */
  // Manage
  /* {
    path: '/property-management',
    name: 'Property Management',
    component: () => import('../views/PropertyManagement.vue'),
  },
  {
    path: '/forms/lease-appraisal',
    name: 'Lease Appraisal',
    component: () => import('../views/LeaseAppraisal.vue'),
  }, */
  // Contact Us
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: () => import('../views/ContactUs.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/forms/notice-of-intention-to-leave',
    name: 'Notice of Intention to Leave',
    component: () => import('../views/Form13.vue'),
  },
  {
    path: '/tv-display/sales',
    name: 'TV Display Sales',
    component: () => import('../views/TVDisplaySales.vue'),
    meta: {
      hide: true,
      hideAncillaries: true, // Disables the header and footer
    },
  },
  {
    path: '/tv-display/rentals',
    name: 'TV Display Rentals',
    component: () => import('../views/TVDisplayRentals.vue'),
    meta: {
      hide: true,
      hideAncillaries: true, // Disables the header and footer
    },
  },
  {
    path: '/listings/:id',
    name: 'Listing',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingDetails.vue'),
  },
  {
    path: '/listings/:id/make-an-offer',
    name: 'Make an Offer',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingMakeAnOffer.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/profiles/:id/appraisal',
    name: 'Profile Appraisal',
    meta: { hide: true },
    component: () => import('../views/AgentProfileAppraisal.vue'),
  },
  {
    path: '/blogs/:id',
    name: 'Blog',
    meta: {
      hide: true,
    },
    component: () => import('../views/BlogDetails.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('../views/Unsubscribe.vue'),
  },
  {
    path: '/*',
    name: 'Not Found',
    meta: {
      hide: true,
    },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
